import { useMemo } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAssemblySteps } from './categoryBands';
import { namedIn, withLetter } from './partsCatalogue';
import { usePartsRun } from './partsRun';
import { pieceNames, useStepsRun } from './stepsRun';

// A PART OR A PIECE BY ITS ANALYSIS ID, as a sentence names it: "Side rail (C)", or a piece made
// earlier as its chip does, "102 – Left rail with first barrel nut". What a rule's reason for not
// placing a sub-step says (see Declined) — an id alone told nobody which part.
export function usePartLabel(docId: string): (id: string) => string {
  const { language } = useLanguage();
  const { steps } = useAssemblySteps(docId);
  const { subSteps } = useStepsRun(docId);
  const { items } = usePartsRun(docId);
  return useMemo(() => {
    const pieces = pieceNames(steps, subSteps, language);
    return (id: string) => {
      const p = items[Number(id)];
      if (p) return withLetter(namedIn(p, language) || `#${id}`, p.letter);
      const made = pieces.get(id)?.name;
      return made ? `${id} – ${made}` : `#${id}`;
    };
  }, [steps, subSteps, items, language]);
}
